"use client";

import type { VoiceListBlock } from "@mw/shared/payload-types";

import dynamic from "next/dynamic";

const VoiceList = dynamic(() => import("./BlockVoiceList").then(mod => mod.VoiceList));

export const BlockVoiceListWrapper = (props: VoiceListBlock) => {
  return <VoiceList {...props} />;
};
